///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.features = abcsetup.features || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.features = {
    /**
     * Is the given feature enabled?
     *
     * @param {string} name
     * @returns {boolean}
     */
    isEnabled(name) {
        name = name.toLowerCase();
        const featuresElement = $('#app_feature_settings');

        if (featuresElement.length === 0) {
            console.error('Cannot check feature status. Features element not found on the page.');
            return false;
        }

        const features = JSON.parse(featuresElement.val());

        if (!features.hasOwnProperty('status') || !_.isPlainObject(features.status)) {
            console.error('Cannot check feature status. Features object is invalid: ', features);
            return false;
        }

        if (!features.status.hasOwnProperty(name)) {
            console.warn(`Feature has not been added yet: ${name}`);
            return false;
        }

        return features.status[name];
    }
}
